import { useEffect } from "react";
import { useThemeMode } from "../components/ThemeMode";
import { COMPANY, Icon, ICONS, MAPS_URL, SectionLink, SiteFooter, SiteNav, useReveal } from "../components/site/SiteChrome";
import InquiryForm from "../components/site/InquiryForm";
import "./LandingPage.css";

const InfoCard = ({ icon, title, sub, children }) => (
	<div className="info-card" data-reveal>
		<span className="info-icon">
			<Icon d={icon} size={20} />
		</span>
		<div>
			<h3>{title}</h3>
			{sub && <p className="info-sub">{sub}</p>}
			{children}
		</div>
	</div>
);

export default function Contact() {
	const { mode } = useThemeMode();
	useReveal();

	useEffect(() => {
		document.title = "Contact Testify — Sales, Demos & Support";
		window.scrollTo(0, 0);
		return () => {
			document.title = "Testify";
		};
	}, []);

	return (
		<div className="lp" data-theme={mode}>
			<SiteNav />

			<header className="hero contact-hero">
				<div className="hero-bg" aria-hidden="true">
					<div className="blob blob-1" />
					<div className="blob blob-2" />
					<div className="hero-grid" />
				</div>
				<div className="container contact-head">
					<span className="eyebrow">Get in touch</span>
					<h1>
						Let's talk about <span className="grad-text">your tests.</span>
					</h1>
					<p className="hero-lead">
						Questions about Testify? Want to see a demo, or plan a rollout for your team? We're here to help.
					</p>
				</div>
			</header>

			<section className="contact-section">
				<div className="container contact-grid">
					<div className="contact-form-card" data-reveal>
						<h2>Send us a message</h2>
						<p className="info-sub">Fields marked * are required.</p>
						<InquiryForm type="CONTACT" />
					</div>

					<aside className="contact-info">
						<InfoCard icon={ICONS.mail} title="Email us" sub="Get in touch via email for detailed inquiries">
							<a className="info-link" href={`mailto:${COMPANY.email}`}>
								{COMPANY.email}
							</a>
						</InfoCard>
						<InfoCard icon={ICONS.phone} title="Call us" sub="Speak with our team Monday to Friday">
							<a className="info-link" href={COMPANY.phoneHref}>
								{COMPANY.phone}
							</a>
						</InfoCard>
						<InfoCard icon={ICONS.clock} title="Business hours">
							{COMPANY.hours.map((line) => (
								<p key={line} className="info-line">
									{line}
								</p>
							))}
						</InfoCard>
						<InfoCard icon={ICONS.pin} title="Visit us">
							<address className="info-line">
								{COMPANY.address.map((line) => (
									<span key={line}>
										{line}
										<br />
									</span>
								))}
							</address>
							<a className="info-link" href={MAPS_URL} target="_blank" rel="noopener noreferrer">
								Open in Google Maps <Icon d={ICONS.arrow} size={14} />
							</a>
						</InfoCard>
						<div className="info-card info-cta" data-reveal>
							<span className="info-icon">
								<Icon d={ICONS.calendar} size={20} />
							</span>
							<div>
								<h3>Want to see it in action?</h3>
								<p className="info-sub">Book a walkthrough on your own app.</p>
								<SectionLink hash="#demo" className="info-link">
									Request a demo <Icon d={ICONS.arrow} size={14} />
								</SectionLink>
							</div>
						</div>
					</aside>
				</div>
			</section>

			<SiteFooter />
		</div>
	);
}
